import {DragDropModule} from '@angular/cdk/drag-drop';
import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatDialogModule} from '@angular/material/dialog';
import {MatDividerModule} from '@angular/material/divider';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatMenuModule} from '@angular/material/menu';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatTooltipModule} from '@angular/material/tooltip';
import {TranslateModule} from '@ngx-translate/core';
import {Q9TrackDirective, Q9TransformPipe} from '@q9elements/ui-kit/common';
import {
  DialogCloseButtonComponent,
  GridDateFilterComponent,
  GridNumericFilterComponent,
  GridTextFilterComponent,
  GridRichTextFilterComponent,
  IconButtonComponent,
  PlaceholderModule,
  PrimaryButtonComponent,
  SecondaryButtonComponent,
  SectionComponent,
  SelectModule,
  TextFieldComponent,
  InfoMessageComponent
} from '@q9elements/ui-kit/components';

import {DeleteViewDialogComponent} from './components/delete-view-dialog/delete-view-dialog.component';
import {EditFiltersDialogComponent} from './components/edit-filters-dialog/edit-filters-dialog.component';
import {EditViewDialogComponent} from './components/edit-view-dialog/edit-view-dialog.component';
import {GridViewsComponent} from './grid-views.component';
import {GridViewsDaoService} from './services/grid-views-dao.service';
import {GridViewsDialogService} from './services/grid-views-dialog.service';
import {GridViewsService} from './services/grid-views.service';

@NgModule({
  declarations: [
    GridViewsComponent,
    EditViewDialogComponent,
    DeleteViewDialogComponent,
    EditFiltersDialogComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    Q9TransformPipe,
    MatFormFieldModule,
    MatProgressSpinnerModule,
    Q9TrackDirective,
    MatDividerModule,
    MatTooltipModule,
    DragDropModule,
    MatDialogModule,
    ReactiveFormsModule,
    TextFieldComponent,
    DialogCloseButtonComponent,
    SecondaryButtonComponent,
    PrimaryButtonComponent,
    SectionComponent,
    MatCardModule,
    IconButtonComponent,
    SelectModule,
    GridDateFilterComponent,
    GridNumericFilterComponent,
    GridTextFilterComponent,
    GridRichTextFilterComponent,
    PlaceholderModule,
    TranslateModule,
    FormsModule,
    InfoMessageComponent
  ],
  exports: [GridViewsComponent],
  providers: [GridViewsService, GridViewsDaoService, GridViewsDialogService]
})
export class GridViewsModule {}
